import { useEffect, useState } from "react";
import {
  PRICING_PLANS, PRICING_FAQS, COMPARISON_ROWS,
  getPlanPrice, getOriginalPrice, getAnnualBilledNote,
} from "../Website/pricingData";


const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="9" fill="currentColor" opacity="0.12" />
    <path d="M5.5 9.2L7.8 11.5L12.5 6.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const XIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="9" fill="currentColor" opacity="0.08" />
    <path d="M6.5 6.5L11.5 11.5M11.5 6.5L6.5 11.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
    <path d="M7 0L8.6 5.1H14L9.7 8.2L11.3 13.3L7 10.2L2.7 13.3L4.3 8.2L0 5.1H5.4L7 0Z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.612.638l4.725-1.217A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.352 0-4.55-.683-6.406-1.86l-.252-.163-3.048.785.822-2.998-.177-.265A9.954 9.954 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
  </svg>
);

// Plans, prices, comparison rows and FAQs are shared with the home page (#pricing).
const plans = PRICING_PLANS;
const faqs = PRICING_FAQS;

export default function PricingPage() {
  const [hoveredPlan, setHoveredPlan] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);
  const [annual, setAnnual] = useState(false);
const currencyToCountry = {
  INR: "IN",
  AED: "AE",
  USD: "US",
};

const getDefaultCountry = () => {
  const currency = localStorage.getItem("currency");
  return currencyToCountry[currency] || "IN";
};

const [country, setCountry] = useState(getDefaultCountry());
const [countries, setCountries] = useState([
  { code: "IN", name: "India" },
  { code: "AE", name: "UAE" },
  { code: "US", name: "USA" },
]);
const openWhatsAppChat = () => {
  window.open("https://wa.me/971561303601", "_blank", "noopener,noreferrer");
};
useEffect(() => {
  const currency = localStorage.getItem("currency");
  if (currency && currencyToCountry[currency]) {
    setCountry(currencyToCountry[currency]);
  }
}, []);
  return (
    <div style={styles.wrapper}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,500;0,9..144,700;1,9..144,400&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-6px); }
        }
        .pricing-card {
          transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
        }
        .pricing-card:hover {
          transform: translateY(-8px);
        }
        .pricing-card.featured {
          transform: translateY(-4px);
        }
        .pricing-card.featured:hover {
          transform: translateY(-12px);
        }
        .cta-btn {
          transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
          position: relative;
          overflow: hidden;
        }
        .cta-btn::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.15) 50%, transparent 70%);
          background-size: 200% 100%;
          opacity: 0;
          transition: opacity 0.3s;
        }
        .cta-btn:hover::after {
          opacity: 1;
          animation: shimmer 1.5s ease infinite;
        }
        .cta-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        }
        .faq-item {
          transition: all 0.3s ease;
        }
        .faq-answer {
          overflow: hidden;
          transition: max-height 0.4s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.3s ease, padding 0.3s ease;
        }
        .toggle-track {
          transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
        }
        .toggle-thumb {
          transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
        }
        .badge-pop {
          animation: float 3s ease-in-out infinite;
        }
        .feature-row {
          transition: all 0.2s ease;
        }
        .feature-row:hover {
          background: rgba(0,0,0,0.015);
          padding-left: 4px;
        }
      `}</style>

      {/* Background pattern */}
      <div style={styles.bgPattern} />

      {/* Header */}
      <div style={styles.header}>
        <div style={{
          animation: "fadeUp 0.7s ease forwards",
          opacity: 0,
          animationDelay: "0.1s",
          animationFillMode: "forwards",
        }}>
          <span style={styles.eyebrow}>Simple, transparent pricing</span>
        </div>
        <h1 style={{
          ...styles.title,
          animation: "fadeUp 0.7s ease forwards",
          opacity: 0,
          animationDelay: "0.2s",
          animationFillMode: "forwards",
        }}>
          Choose the plan that<br />
          <span style={styles.titleAccent}>scales with you</span>
        </h1>
        <p style={{
          ...styles.subtitle,
          animation: "fadeUp 0.7s ease forwards",
          opacity: 0,
          animationDelay: "0.3s",
          animationFillMode: "forwards",
        }}>
          From solo operators to enterprise fleets — manage orders, crew, and
          customer communication from one platform.
        </p>

        {/* Billing toggle */}
        <div style={styles.countryWrap}>
  <label style={styles.countryLabel}>Select Country</label>
  <select
    value={country}
    onChange={(e) => setCountry(e.target.value)}
    style={styles.countrySelect}
  >
    {countries.map((c) => (
      <option key={c.code} value={c.code}>
        {c.name}
      </option>
    ))}
  </select>
</div>
        <div style={{
          ...styles.toggleWrap,
          animation: "fadeUp 0.7s ease forwards",
          opacity: 0,
          animationDelay: "0.4s",
          animationFillMode: "forwards",
        }}>
          <span style={{ ...styles.toggleLabel, opacity: annual ? 0.5 : 1, fontWeight: annual ? 400 : 600 }}>Monthly</span>
          <div
            className="toggle-track"
            onClick={() => setAnnual(!annual)}
            style={{
              ...styles.toggleTrack,
              background: annual ? "#d01c4c" : "#d0d5dd",
            }}
          >
            <div
              className="toggle-thumb"
              style={{
                ...styles.toggleThumb,
                transform: annual ? "translateX(22px)" : "translateX(2px)",
              }}
            />
          </div>
          <span style={{ ...styles.toggleLabel, opacity: annual ? 1 : 0.5, fontWeight: annual ? 600 : 400 }}>
            Annual
            <span style={styles.saveBadge}>Save Additional 20%</span>
          </span>
        </div>
      </div>

      {/* Plans Grid */}
      <div style={styles.grid}>
        {plans.map((plan, i) => {
          const isFeatured = plan.id === "pro";
    const getPrice = () => getPlanPrice(plan, country, annual);

const displayPrice = getPrice();
          // const displayPrice = plan.price === "Free" || plan.price === "Custom"
          //   ? plan.price
          //   : annual ? "$79" : "$99";

          return (
            <div
              key={plan.id}
              className={`pricing-card ${isFeatured ? "featured" : ""}`}
              onMouseEnter={() => setHoveredPlan(plan.id)}
              onMouseLeave={() => setHoveredPlan(null)}
              style={{
                ...styles.card,
                ...(isFeatured ? styles.cardFeatured : {}),
                animation: `scaleIn 0.6s ease forwards`,
                opacity: 0,
                animationDelay: `${0.3 + i * 0.12}s`,
                animationFillMode: "forwards",
                border: isFeatured
                  ? "2px solid #c22a3a"
                  : "1.5px solid #e8e8ed",
              }}
            >
              {isFeatured && (
                <div className="badge-pop" style={styles.popularBadge}>
                  <StarIcon /> {plan.badge}
                </div>
              )}

              <div style={styles.cardHeader}>
                {/* <span style={{
                  ...styles.planName,
                  color: isFeatured ? "#1a1a2e" : "#555",
                }}>{plan.name}</span> */}
                <span
  style={
    plan.id === "pro"
      ? {
          background: "#d01c4c",
          color: "#fff",
          padding: "4px 10px",
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: 600,
          display: "inline-block",
        }
      : styles.planName
  }
>
  {plan.name}
</span>
                <span style={styles.planTagline}>{plan.tagline}</span>
              </div>

              <div style={styles.priceBlock}>
                {plan.originalPrice && !annual && (
                  <span style={styles.originalPrice}>
                    {getOriginalPrice(country)}
                  </span>
                )}
                <div style={styles.priceRow}>
                  <span style={{
                    ...styles.price,
                    fontSize: plan.price === "Custom" ? "32px" : "48px",
                  }}>
                    {displayPrice}
                  </span>
                  {plan.period && (
                    <span style={styles.period}>{plan.period}</span>
                  )}
                </div>
                {plan.id === "pro" && annual && (
                  <span style={styles.billedNote}>
                    Billed annually at{" "}
                    {getAnnualBilledNote(country)}
                  </span>
                )}
              </div>

              <div style={styles.divider} />

              <div style={styles.featuresList}>
                {plan.features.map((f, fi) => (
                  <div
                    key={fi}
                    className="feature-row"
                    style={{
                      ...styles.featureRow,
                      opacity: f.included ? 1 : 0.4,
                    }}
                  >
                    <span style={{
                      ...styles.featureIcon,
                      color: f.included
                        ? (f.highlight ? "#16a34a" : "#1a1a2e")
                        : "#aaa",
                    }}>
                      {f.included ? <CheckIcon /> : <XIcon />}
                    </span>
                    <span style={styles.featureText}>
                      {(f.icon === "whatsapp" || f.whatsapp) && (
                        <span style={styles.whatsappIcon}><WhatsAppIcon /></span>
                      )}
                      {f.text}
                      {f.note && <span style={styles.featureNote}> · {f.note}</span>}
                    </span>
                  </div>
                ))}
              </div>

              {plan.footnote && (
                <div style={styles.footnote}>
                  <span style={styles.footnoteIcon}>ℹ</span>
                  {plan.footnote}
                </div>
              )}

            {plan.id !== "pro" && (
  <button
    className="cta-btn"
    onClick={() => plan.cta === "Contact Sales" ? openWhatsAppChat() : undefined}
    style={{
      ...styles.ctaBase,
      ...(plan.ctaStyle === "primary" ? styles.ctaPrimary : {}),
      ...(plan.ctaStyle === "dark" ? styles.ctaDark : {}),
      ...(plan.ctaStyle === "secondary" ? styles.ctaSecondary : {}),
      marginTop: "auto",
    }}
  >
    <span style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
      {plan.cta} <ArrowIcon />
    </span>
  </button>
)}
            </div>
          );
        })}
      </div>

      {/* Trust strip */}
      <div style={{
        ...styles.trustStrip,
        animation: "fadeUp 0.7s ease forwards",
        opacity: 0,
        animationDelay: "0.8s",
        animationFillMode: "forwards",
      }}>
        <div style={styles.trustItem}>
          <span style={styles.trustIcon}>🔒</span>
          <span>256-bit encryption</span>
        </div>
        <div style={styles.trustDot} />
        <div style={styles.trustItem}>
          <span style={styles.trustIcon}>⚡</span>
          <span>99.9% uptime SLA</span>
        </div>
        <div style={styles.trustDot} />
        <div style={styles.trustItem}>
          <span style={styles.trustIcon}>↩️</span>
          <span>Cancel anytime</span>
        </div>
        <div style={styles.trustDot} />
        <div style={styles.trustItem}>
          <span style={styles.trustIcon}>💬</span>
          <span>Priority support</span>
        </div>
      </div>

      {/* Comparison Table */}
      <div style={{
        ...styles.compSection,
        animation: "fadeUp 0.7s ease forwards",
        opacity: 0,
        animationDelay: "0.9s",
        animationFillMode: "forwards",
      }}>
        <h2 style={styles.compTitle}>Full feature comparison</h2>
        <div style={styles.compTable}>
          <div style={styles.compHeaderRow}>
            <div style={{ ...styles.compCell, ...styles.compFeatureCell }}>Features</div>
            <div style={{ ...styles.compCell, ...styles.compPlanCell }}>Starter</div>
            <div style={{ ...styles.compCell, ...styles.compPlanCell, ...styles.compHighlight }}>Pro</div>
            <div style={{ ...styles.compCell, ...styles.compPlanCell }}>Enterprise</div>
          </div>
          {COMPARISON_ROWS.map(([feature, s, p, e], ri) => (
            <div key={ri} style={{
              ...styles.compRow,
              background: ri % 2 === 0 ? "transparent" : "rgba(0,0,0,0.015)",
            }}>
              <div style={{ ...styles.compCell, ...styles.compFeatureCell, fontWeight: 500 }}>{feature}</div>
              <div style={{ ...styles.compCell, ...styles.compPlanCell, color: s === "—" ? "#bbb" : "#444" }}>{s}</div>
              <div style={{ ...styles.compCell, ...styles.compPlanCell, ...styles.compHighlight, color: p === "—" ? "#bbb" : "#1a1a2e", fontWeight: p === "—" ? 400 : 500 }}>{p}</div>
              <div style={{ ...styles.compCell, ...styles.compPlanCell, color: e === "—" ? "#bbb" : "#444" }}>{e}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div style={{
        ...styles.faqSection,
        animation: "fadeUp 0.7s ease forwards",
        opacity: 0,
        animationDelay: "1s",
        animationFillMode: "forwards",
      }}>
        <h2 style={styles.faqTitle}>Common questions</h2>
        <div style={styles.faqList}>
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="faq-item"
              style={{
                ...styles.faqItem,
                borderColor: openFaq === i ? "#1a1a2e" : "#e8e8ed",
              }}
              onClick={() => setOpenFaq(openFaq === i ? null : i)}
            >
              <div style={styles.faqQuestion}>
                <span style={styles.faqQ}>{faq.q}</span>
                <span style={{
                  ...styles.faqToggle,
                  transform: openFaq === i ? "rotate(45deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}>+</span>
              </div>
              <div
                className="faq-answer"
                style={{
                  maxHeight: openFaq === i ? "200px" : "0px",
                  opacity: openFaq === i ? 1 : 0,
                  paddingTop: openFaq === i ? "12px" : "0px",
                }}
              >
                <p style={styles.faqA}>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Banner */}
      <div style={{
        ...styles.ctaBanner,
        animation: "fadeUp 0.7s ease forwards",
        opacity: 0,
        animationDelay: "1.1s",
        animationFillMode: "forwards",
      }}>
        <div style={styles.ctaBannerInner}>
          <h3 style={styles.ctaBannerTitle}>Ready to streamline your operations?</h3>
          <p style={styles.ctaBannerSub}>Join thousands of businesses managing orders, crew, and customers — all in one place.</p>
          <div style={styles.ctaBannerButtons}>
            <button className="cta-btn" style={{ ...styles.ctaBase, ...styles.ctaBannerPrimary }}>
              <span style={{ position: "relative", zIndex: 1, display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
                Start free trial <ArrowIcon />
              </span>
            </button>
            <button
              className="cta-btn"
              style={{ ...styles.ctaBase, ...styles.ctaBannerSecondary }}
              onClick={openWhatsAppChat}
            >
              Talk to sales
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  countryWrap: {
  marginTop: "24px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "6px",
},

countryLabel: {
  fontSize: "13px",
  color: "#666",
  fontWeight: 500,
},

countrySelect: {
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e0e0e5",
  fontSize: "14px",
  fontFamily: "'DM Sans', sans-serif",
  cursor: "pointer",
  outline: "none",
  minWidth: "160px",
},
  wrapper: {
    fontFamily: "'DM Sans', -apple-system, sans-serif",
    color: "#1a1a2e",
    minHeight: "100vh",
    position: "relative",
    overflow: "hidden",
    background: "#fafafa",
    padding: "0 20px 60px",
  },
  bgPattern: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "600px",
    background: "radial-gradient(ellipse 80% 50% at 50% -20%, rgba(26,26,46,0.06) 0%, transparent 100%)",
    pointerEvents: "none",
  },
  header: {
    textAlign: "center",
    padding: "60px 20px 40px",
    maxWidth: "680px",
    margin: "0 auto",
    position: "relative",
  },
  eyebrow: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "#888",
    display: "block",
    marginBottom: "16px",
  },
  title: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: "clamp(32px, 5vw, 52px)",
    fontWeight: 700,
    lineHeight: 1.15,
    color: "#1a1a2e",
    marginBottom: "20px",
    letterSpacing: "-0.5px",
  },
  titleAccent: {
    fontStyle: "italic",
    fontWeight: 300,
    background: "linear-gradient(135deg, #1a1a2e 0%, #4a4a6a 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subtitle: {
    fontSize: "17px",
    lineHeight: 1.65,
    color: "#666",
    maxWidth: "520px",
    margin: "0 auto",
  },
  toggleWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    marginTop: "32px",
  },
  toggleLabel: {
    fontSize: "14px",
    color: "#1a1a2e",
    transition: "all 0.3s",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    userSelect: "none",
  },
  toggleTrack: {
    width: "46px",
    height: "24px",
    borderRadius: "12px",
    cursor: "pointer",
    position: "relative",
    flexShrink: 0,
  },
  toggleThumb: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    background: "white",
    position: "absolute",
    top: "2px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
  },
  saveBadge: {
    fontSize: "11px",
    fontWeight: 600,
    background: "#dcfce7",
    color: "#16a34a",
    padding: "3px 8px",
    borderRadius: "20px",
    letterSpacing: "0.2px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "24px",
    maxWidth: "1040px",
    margin: "20px auto 0",
    position: "relative",
    alignItems: "start",
  },
  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "36px 30px 30px",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    minHeight: "520px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.04)",
  },
  cardFeatured: {
    boxShadow: "0 4px 12px rgba(0,0,0,0.06), 0 20px 48px rgba(26,26,46,0.1)",
  },
  popularBadge: {
    position: "absolute",
    top: "-13px",
    left: "50%",
    transform: "translateX(-50%)",
   background: "#d01c4c",
color: "#fff",
    fontSize: "12px",
    fontWeight: 600,
    padding: "6px 18px",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    letterSpacing: "0.3px",
    whiteSpace: "nowrap",
    boxShadow: "0 4px 12px rgba(26,26,46,0.3)",
  },
  cardHeader: {
    marginBottom: "24px",
  },
  planName: {
    fontSize: "22px",
    fontWeight: 700,
    display: "block",
    marginBottom: "4px",
    fontFamily: "'Fraunces', Georgia, serif",
  },
  planTagline: {
    fontSize: "14px",
    color: "#888",
  },
  priceBlock: {
    marginBottom: "24px",
  },
  originalPrice: {
    fontSize: "16px",
    color: "#aaa",
    textDecoration: "line-through",
    display: "block",
    marginBottom: "2px",
  },
  priceRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "4px",
  },
  price: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontWeight: 700,
    color: "#1a1a2e",
    lineHeight: 1,
  },
  period: {
    fontSize: "15px",
    color: "#888",
    fontWeight: 400,
  },
  billedNote: {
    fontSize: "12px",
    color: "#16a34a",
    fontWeight: 500,
    marginTop: "4px",
    display: "block",
  },
  divider: {
    height: "1px",
    background: "linear-gradient(to right, transparent, #e8e8ed, transparent)",
    marginBottom: "24px",
  },
  featuresList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "28px",
    flex: 1,
  },
  featureRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    borderRadius: "8px",
    padding: "2px 0",
  },
  featureIcon: {
    flexShrink: 0,
    marginTop: "1px",
  },
  featureText: {
    fontSize: "14px",
    lineHeight: 1.5,
    color: "#444",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexWrap: "wrap",
  },
  whatsappIcon: {
    color: "#25D366",
    display: "inline-flex",
    flexShrink: 0,
  },
  featureNote: {
    fontSize: "12px",
    color: "#888",
    fontStyle: "italic",
  },
  footnote: {
    fontSize: "12px",
    color: "#888",
    background: "#f8f8fa",
    padding: "10px 14px",
    borderRadius: "10px",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    lineHeight: 1.5,
  },
  footnoteIcon: {
    fontSize: "14px",
    opacity: 0.6,
    flexShrink: 0,
  },
  ctaBase: {
    width: "100%",
    padding: "14px 24px",
    borderRadius: "12px",
    fontSize: "15px",
    fontWeight: 600,
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    border: "none",
    display: "block",
  },
ctaPrimary: {
  background: "#d01c4c", // danger
  color: "#fff",
  boxShadow: "0 4px 14px rgba(208,28,76,0.3)",
},

ctaSecondary: {
  background: "#d01c4c",
  color: "#fff",
  border: "none",
},

ctaDark: {
  background: "#d01c4c",
  color: "#fff",
  boxShadow: "0 4px 14px rgba(220,53,69,0.35)",
},
  trustStrip: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    padding: "40px 20px",
    maxWidth: "800px",
    margin: "0 auto",
  },
  trustItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    color: "#666",
    fontWeight: 500,
  },
  trustIcon: {
    fontSize: "16px",
  },
  trustDot: {
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    background: "#ccc",
  },
  compSection: {
    maxWidth: "960px",
    margin: "20px auto 0",
    padding: "0 0 40px",
  },
  compTitle: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: "28px",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: "32px",
    color: "#1a1a2e",
  },
  compTable: {
    borderRadius: "16px",
    overflow: "hidden",
    border: "1.5px solid #e8e8ed",
    background: "#fff",
  },
  compHeaderRow: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1fr",
    background: "#d01c4c",
    color: "#fff",
  },
  compRow: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1fr",
    borderBottom: "1px solid #f0f0f3",
  },
  compCell: {
    padding: "14px 20px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
  },
  compFeatureCell: {
    color: "#444",
  },
  compPlanCell: {
    justifyContent: "center",
    textAlign: "center",
    fontSize: "13px",
  },
  compHighlight: {
    background: "rgba(26,26,46,0.03)",
  },
  faqSection: {
    maxWidth: "680px",
    margin: "20px auto 0",
    padding: "0 0 40px",
  },
  faqTitle: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: "28px",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: "32px",
    color: "#1a1a2e",
  },
  faqList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  faqItem: {
    border: "1.5px solid #e8e8ed",
    borderRadius: "14px",
    padding: "20px 24px",
    cursor: "pointer",
    background: "#fff",
    transition: "border-color 0.3s",
  },
  faqQuestion: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
  },
  faqQ: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1a1a2e",
    lineHeight: 1.4,
  },
  faqToggle: {
    fontSize: "22px",
    fontWeight: 300,
    color: "#888",
    flexShrink: 0,
    width: "24px",
    textAlign: "center",
  },
  faqA: {
    fontSize: "14px",
    lineHeight: 1.7,
    color: "#666",
  },
  ctaBanner: {
    maxWidth: "960px",
    margin: "20px auto 0",
  },
  ctaBannerInner: {
    background: "#d01c4c",
    borderRadius: "24px",
    padding: "56px 40px",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  },
  ctaBannerTitle: {
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: "clamp(24px, 3.5vw, 34px)",
    fontWeight: 700,
    color: "#fff",
    marginBottom: "12px",
  },
  ctaBannerSub: {
    fontSize: "16px",
    color: "rgba(255,255,255,0.65)",
    maxWidth: "480px",
    margin: "0 auto 32px",
    lineHeight: 1.6,
  },
  ctaBannerButtons: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  ctaBannerPrimary: {
    width: "auto",
    padding: "14px 32px",
    background: "#fff",
    color: "#1a1a2e",
    borderRadius: "12px",
    fontWeight: 600,
  },
  ctaBannerSecondary: {
    width: "auto",
    padding: "14px 32px",
    background: "transparent",
    color: "#fff",
    border: "1.5px solid rgba(255,255,255,0.25)",
    borderRadius: "12px",
    fontWeight: 500,
  },
};
